export class AplicacaoCredenciaisDadosModel {
    constructor(
        public id: string = '',
        public confirmacaoAutomaticaAtivada: boolean = true,
        public credenciais: Record<string, string> = {}
    ) { }
    credenciar(credenciais: Record<string, string>) {
        this.credenciais = credenciais
    }
}